import type { FeatureFlags } from '~/helpers/typescript';

/** Beta-preference cookie keys — must match Daffy's BETA_COOKIE_REGISTRY (beta/views.py). */
export type BetaKey = 'betaRoutes' | 'fepSidenav';

/** Surface consuming the controller — drives telemetry attribution and nav strategy. */
export type BetaSource = 'settings' | 'agentMenu' | 'banner';

/**
 * Each beta key and the LaunchDarkly flag gating it. A key is only surfaced once its org
 * has the flag enabled. Add a row here (and a matching registry entry server-side) to
 * expose a new beta cookie.
 */
export const BETA_COOKIE_OPTIONS: { key: BetaKey; ldFlag: keyof FeatureFlags }[] = [
  { key: 'fepSidenav', ldFlag: 'fepSidenav' },
  { key: 'betaRoutes', ldFlag: 'betaRoutesEnabled' },
];

/**
 * Coupling: the new sidenav is bundled into the beta dashboard routes experience, so
 * enabling `betaRoutes` also enables `fepSidenav` (when the org still has it flagged in),
 * and locks the sidenav toggle read-only while betaRoutes is active.
 */
export const COUPLED_ON: Partial<Record<BetaKey, BetaKey>> = {
  betaRoutes: 'fepSidenav',
};

/** Datadog RUM action fired on every toggle, tagged with `{ key, enabled, source }`. */
export const BETA_TOGGLE_DD_ACTION = 'betaFeatures-toggle';

/** Generic, label-free failure copy (labels are surface-owned, so no key name is shown). */
export const BETA_WRITE_ERROR_COPY = "Couldn't save your beta setting. Please try again.";
